<div class="provider-card surface">
  <div class="provider-card-actions">
    <button class="provider-action" type="button" (click)="onEdit()" [title]="'providers.edit' | translate">
      <span class="material-symbols-outlined">edit</span>
    </button>
    <button class="provider-action delete" type="button" (click)="onDelete()" [title]="'providers.delete' | translate">
      <span class="material-symbols-outlined">delete</span>
    </button>
  </div>

  <div class="provider-title">{{ provider.ProviderType }}</div>

  <div class="provider-detail">
    <strong>{{ 'providers.card_url' | translate }}</strong>
    <span>{{ provider.Url }}</span>
  </div>

  <div class="provider-detail" *ngIf="provider.ApiKey">
    <strong>{{ 'providers.card_api_key' | translate }}</strong>
    <span>{{ provider.ApiKey }}</span>
  </div>

  <div class="provider-detail" *ngIf="provider.Username">
    <strong>{{ 'providers.card_username' | translate }}</strong>
    <span>{{ provider.Username }}</span>
  </div>
</div>
